import script from "./Ticker.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ticker.vue?vue&type=script&setup=true&lang=ts"

import "./Ticker.vue?vue&type=style&index=0&id=5d881e68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d881e68"]])

export default __exports__